import { useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import compLine from '../Images/compLine.png';
import './NewProducts.css';

const media = (name) => `/static/media/${name}`;

const image = {
  led: media('leds.ec365a6f20a1b9c31b63.jpg'),
  home: media('home_product.62b541976f992438c7dd.jpg'),
  flake: media('flake.7da5d2be5234215eaea4.webp'),
  electricTurnkey: media('electricturnkey.4cfbe0b15171cced9457.jpeg'),
  industrialLed: media('indcti.b49c6b488a321adfc458.jpeg'),
  industrialSmartLed: media('in.93f97b4faa6513bc534b.jpeg'),
  domesticLed: media('cttii.787467a91af79b86739a.jpeg'),
  domesticSmartLed: media('smartlight.c24c2242a9bd0c0cec2d.jpg'),
  retrofit: media('homeautomation.b3d2f9079373a21ca522.jpg'),
  touchPanel: media('interface.6e07b0c6eb2e3c852103.png'),
  starter: media('starter.1ab84bf1f9622d977d57.jpeg'),
  smartAmbient: media('smartambient.9ccc6db5215423363789.jpg'),
  simulator: media('simulators.1cc1e2d8ae0f75eb9190.jpeg'),
  meter: media('meter.4b5e8ef066412d3a73b0.jpeg'),
  smartWater: media('smartwatermotoring.c27882625f95190f5f60.jpg'),
  smartStreet: media('smartledcti.cae94d806a61388737eb.jpeg'),
  homeAutomation: media('homeautomation.b3d2f9079373a21ca522.jpg'),
  smartTraffic: media('smartlight.c24c2242a9bd0c0cec2d.jpg'),
  waterHeater: media('waterheater.9c397f8bc959fb041c4a.jpg'),
  solarStreet: media('street.759700bfaaf85d51cc49.jpg'),
  solarTurnkey: media('solarturnkey.1a7db6a8507a39a3dde5.jpg'),
  industrialSolar: media('industrialsolar.2da24494409309cdeab6.jpg'),
};

const SectionHeading = ({ children, showStore, onStore }) => (
  <div className="iotSol__head">
    <div className="iotSol__headImg1">
      <h2 className="heading_products"><strong>{children}</strong></h2>
      <img src={compLine} alt="" />
      {showStore && (
        <div style={{ marginLeft: '2rem' }}>
          <button className="store-btn" onClick={onStore}>Go To Store</button>
        </div>
      )}
    </div>
  </div>
);

const ProductCard = ({ item, onSelect, compact = false }) => (
  <div className="card" style={compact ? { width: '18rem', height: '32rem' } : { margin: '3rem' }}>
    <img
      className="card-img-top"
      src={item.src}
      alt={item.category}
      style={{ height: compact ? '15rem' : '20rem', objectFit: 'cover' }}
    />
    <div className={compact ? 'card-body' : 'card-block'}>
      <h4 className="card-title">{item.category}</h4>
      <p className="card-text">{item.desc}</p>
      <Link to="/product">
        <button className="btn btn-primary" onClick={() => onSelect(item)}>Know More</button>
      </Link>
    </div>
  </div>
);

export default function NewProducts() {
  const navigate = useNavigate();
  const ledLightsRef = useRef(null);

  const products = [
    { id: 16, category: 'LED Lightning', desc: 'Energy-efficient, customizable color temperature, eco-friendly, and provides bright, flicker-free illumination for various applications.', src: image.led },
    { id: 3, category: 'Home Automation', desc: 'Discover the future of living with our smart home automation solutions. Control lighting, climate, security, and more for ultimate convenience.', src: image.home },
    { id: 10, category: 'Tube and Flake Ice Plant', desc: 'High ice production, energy-efficient, automated controls, stainless steel construction, easy maintenance, and customizable sizing options.', src: image.flake },
    { id: 18, category: 'Electrical Turnkey', desc: 'Project management, design, installation, testing, and commissioning services for hassle-free, efficient electrical systems implementation.', src: image.electricTurnkey },
  ];

  const led = [
    { id: 1, category: 'Industrial Ordinary LED Lights', desc: 'Durable and eco-friendly. Superior illumination for industrial spaces, with customizable options.', src: image.industrialLed },
    { id: 2, category: 'Industrial Smart LED Lights', desc: 'Tailor lighting for productivity in industrial spaces, promoting sustainability and performance.', src: image.industrialSmartLed },
    { id: 3, category: 'Domestic Ordinary LED Lights', desc: 'Customizable illumination promoting energy savings and comfort.', src: image.domesticLed },
    { id: 4, category: 'Domestic Smart LED Lights', desc: 'Innovative, energy-efficient and customizable intelligent lighting for comfort and efficiency.', src: image.domesticSmartLed },
  ];

  const homeAutomation = [
    { id: 1, category: 'Retrofit', desc: 'Upgrade existing setups seamlessly with efficient and customizable technology.', src: image.retrofit },
    { id: 2, category: 'Touch Panel', desc: 'Responsive touch technology for intuitive control and convenient system management.', src: image.touchPanel },
  ];

  const smartFarming = [
    { id: 1, category: 'Smart Motor Controller', desc: 'Optimize farming devices, reduce energy consumption and improve productivity.', src: image.starter },
    { id: 2, category: 'Smart Ambient Controller Condition', desc: 'Optimize environmental conditions for comfort, efficiency and sustainability.', src: image.smartAmbient },
  ];

  const automotive = [
    { id: 1, category: 'Simulators', desc: 'Precision simulators for automotive hardware testing, analysis and reliability.', src: image.simulator },
    { id: 2, category: 'Testing Tools', desc: 'Precision hardware for comprehensive automotive testing and analysis.', src: image.meter },
  ];

  const smartCity = [
    { id: 1, category: 'Smart Water Monitoring', desc: 'Efficient water management through advanced IoT monitoring technology.', src: image.smartWater },
    { id: 2, category: 'Automated Street Lightning', desc: 'Intelligent street lighting solutions for safer and energy-efficient urban environments.', src: image.smartStreet },
    { id: 3, category: 'Home Automation', desc: 'Transform living spaces with modern home automation solutions.', src: image.homeAutomation },
    { id: 4, category: 'Smart Traffic Lightning System', desc: 'Smart, energy-efficient traffic lighting solutions for cities.', src: image.smartTraffic },
  ];

  const solar = [
    { id: 1, category: 'Solar Water Heater', desc: 'Energy-efficient solar water heating for reliable domestic hot water.', src: image.waterHeater },
    { id: 2, category: 'Solar Street Light', desc: 'Automatic dusk-to-dawn, durable and eco-friendly outdoor lighting.', src: image.solarStreet },
    { id: 3, category: 'Solar Turnkey', desc: 'End-to-end solar solutions covering design, installation, permits and grid connection.', src: image.solarTurnkey },
    { id: 5, category: 'Industrial Solar Solution', desc: 'Scalable designs, advanced solar panels and monitoring systems for sustainable energy production.', src: image.industrialSolar },
  ];

  const handleProductClick = (selectedProduct) => {
    localStorage.setItem('selectedProduct', JSON.stringify(selectedProduct));
  };

  const handleNavigate = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate('/ecom');
  };

  const renderGrid = (items) => (
    <div className="newproduct__main">
      {items.map((item) => <ProductCard key={item.id} item={item} onSelect={handleProductClick} compact />)}
    </div>
  );

  const renderDeck = (items) => (
    <div className="card-deck">
      {items.map((item) => <ProductCard key={item.id} item={item} onSelect={handleProductClick} />)}
    </div>
  );

  return (
    <>
      <div className="newproduct__parent">
        <SectionHeading>Our Products</SectionHeading>
        <div style={{ marginLeft: '2rem' }}><button className="store-btn" onClick={handleNavigate}>Go To Store</button></div>
        <div className="iotSol__text">
          <p style={{ marginTop: '2.5%' }}>Our products are also available at amazon.in, flipkart.com, snapdeal.com, shopclues.com, meesho.com and paytm.com for online selling.</p>
        </div>
        {renderGrid(products)}
      </div>

      <section id="led_lights" ref={ledLightsRef}>
        <div className="led_items"><SectionHeading showStore onStore={handleNavigate}>LED Lightning</SectionHeading>{renderGrid(led)}</div>
      </section>

      <section id="home_automation">
        <div className="home_auto_section"><SectionHeading>Home Automation</SectionHeading>{renderDeck(homeAutomation)}</div>
      </section>

      <section id="smart_farming">
        <div className="smart_farming"><SectionHeading>Smart Farming Devices</SectionHeading>{renderDeck(smartFarming)}</div>
      </section>

      <section id="solar_smart">
        <div className="led_items"><SectionHeading>Turnkey Projects</SectionHeading>{renderGrid(solar)}</div>
      </section>

      <section id="smart_city">
        <div className="led_items"><SectionHeading>Smart City Projects</SectionHeading>{renderGrid(smartCity)}</div>
      </section>

      <section id="hardware">
        <div className="hardware_tools"><SectionHeading>Automotive Instruments</SectionHeading>{renderDeck(automotive)}</div>
      </section>
    </>
  );
}
